module.exports = __webpack_public_path__ + "img/checkmark.36320029.svg";